import { useEffect } from 'react';
import { useAppSelector } from 'store/store-hooks';
import { Path, useAppNavigator } from 'components/_hooks/use-router';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';
import styles from './_welcome.module.scss';

export const Welcome = () => {
  const helpMode = useAppSelector(selectHelpMode);
  const { navigateTo } = useAppNavigator();

  useEffect(() => {
    if (helpMode === false) navigateTo(Path.projects);
  }, [helpMode]);

  return (
    <div className={styles.Welcome}>
      <iframe src="https://reflectography.com/a-montage-editor" title="A Montage Editor" />
    </div>
  );
};
